export default function loadModules(
  modules: any,
  getModuleName: (fileName: string) => string = fileName =>
    fileName.slice(2, -3)
) {
  const result: Record<string, any> = {};

  for (const fileName in modules) {
    result[getModuleName(fileName)] = modules[fileName].default;
  }

  return result;
}
